<a
    dsTouchClick
    [href]="globalLink"
    [class.card-without-img]="!backgroundImage"
    [msRemoveHref]="shouldRemoveHref"
    (click)="trackOutrightClicks(tile.index, globalLink, event.sport.id, event.league.id, backgroundImage)">
    @if (backgroundImage) {
        <img placeholder class="marquee-background-image" ngSrcset="1x, 2x, 3x" [width]="133" [height]="85" [ngSrc]="backgroundImage" />
        <div class="card-special-image">
            <ng-container *ngTemplateOutlet="marqueeCardTemplate" />
        </div>
    } @else {
        <div class="outright-participant-name" [style.color]="textColor">{{ tile.name }}</div>
        <ms-option-group
            [optionGroup]="outrightOptionGroup[tile.id]"
            [event]="event"
            [hasImage]="backgroundImage !== ''"
            [tracking]="{ source: '', position: tile.index }" />
    }
</a>

<ng-template #marqueeCardTemplate>
    <div class="outright-participant-name" [style.color]="textColor">{{ tile.name }}</div>
    <ms-option-group
        [optionGroup]="outrightOptionGroup[tile.id]"
        [event]="event"
        [hasImage]="backgroundImage !== ''"
        [tracking]="{ source: '', position: tile.index }" />
</ng-template>
